<template>
  <label>
    <div :style="{ color }" :class="{ active: focused || data_value }" v-if="type!='hidden'">{{ label }}</div>
    <component 
      :is="tag"
      :style="{ color, 'border-color': color }" 
      :value="value"
      :type="type"

      @focus="focused = true" 
      @blur="focused = false"
      v-on:input="updateValue($event.target.value)"
    />
  </label>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    color: { type: String, default: '#484848' },
    tag: { type: String, default: 'input' },
    type: { type: String, default: 'text' },
    value: {
      type: String
    }
  },
  data: () => ({
    focused: false,
    data_value: ''
  }),
  methods: {
    updateValue: function (value) {
      this.$emit('input', value);
      this.data_value=value;
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  width: 100%;
}

input,
textarea {
  background: none;
  border: solid 0px;
  border-bottom-width: 1px;
  outline: none;
  font-size: 16px;
  font-family: inherit;
  padding: 5px 0;
  width: 100%;
  resize: none;
}

textarea {
  height: 60px;
}

div {
  font-size: 14px;
  transition: all 0.3s;
  transform: translateY(20px);
  transform-origin: top left;

  &.active {
    transform: translateY(2px) scale(0.8);
  }
}
</style>